import auth from '@/router/auth'
import NotiType from '@/components/noti-form/NotiType.vue'
import NotiForm from '@/components/noti-form/NotiForm.vue'

export default [
  {
    path: '/cate-noti-type',
    name: 'cate-noti-type',
    component: NotiType,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/cate-noti-form',
    name: 'cate-noti-form',
    component: NotiForm,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/noti-form/router.js